import { Suspense, lazy } from 'react';
import { Link, useLocation } from 'react-router';

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar';

import { handleMenuReClick } from '../lib/menu-refresh';
import { cn } from '../lib/utils';
import { useGetMyPayments } from '../query/payment';
import AppSidebarHeader from './app-sidebar-header';

const GraduationCap = lazy(() =>
  import('lucide-react').then(mod => ({ default: mod.GraduationCap })),
);
const CreditCard = lazy(() => import('lucide-react').then(mod => ({ default: mod.CreditCard })));

const SIDEBARS = [
  {
    id: 'course',
    label: '강좌',
    children: [
      {
        id: 'course',
        label: '강좌관리',
        href: '/course',
        pathnames: ['/course'],
        icon: (
          <Suspense fallback={<div className="w-4 h-4" />}>
            <GraduationCap aria-hidden="true" />
          </Suspense>
        ),
      },
    ],
  },
];

// 결제 이력이 있는 학생에게만 노출한다. (무료 강좌만 듣는 학생에게는 불필요한 메뉴)
const PAYMENT_SIDEBAR = {
  id: 'payment',
  label: '결제',
  children: [
    {
      id: 'payment',
      label: '결제/환불 내역',
      href: '/payment',
      pathnames: ['/payment'],
      icon: (
        <Suspense fallback={<div className="w-4 h-4" />}>
          <CreditCard aria-hidden="true" />
        </Suspense>
      ),
    },
  ],
};

export function AppSidebar() {
  const location = useLocation();
  const pathname = location.pathname;
  const { data: myPayments } = useGetMyPayments();
  const hasPayments = (myPayments?.data?.length ?? 0) > 0;
  const sidebars = hasPayments ? [...SIDEBARS, PAYMENT_SIDEBAR] : SIDEBARS;
  return (
    <Sidebar>
      <AppSidebarHeader />
      <SidebarContent>
        {sidebars.map(sidebar => {
          return (
            <SidebarGroup key={sidebar.id}>
              <SidebarGroupLabel className={cn('font-medium')}>{sidebar.label}</SidebarGroupLabel>
              <SidebarGroupContent>
                <SidebarMenu>
                  {sidebar.children.map(menu => {
                    const { pathnames, icon } = menu;

                    return (
                      <SidebarMenuItem key={menu.id}>
                        <SidebarMenuButton
                          asChild
                          className={`w-full h-10 flex items-center gap-3 px-4 rounded-lg text-sm transition-all duration-200 mb-1 ${
                            pathnames.includes(pathname)
                              ? 'bg-white text-primary-blue font-medium shadow-sm'
                              : 'text-white/90 hover:bg-white/10 hover:text-white'
                          }`}
                        >
                          <Link
                            to={menu.href}
                            onClick={e => {
                              if (
                                handleMenuReClick(menu.href, pathname, () =>
                                  window.location.reload(),
                                )
                              ) {
                                e.preventDefault();
                              }
                            }}
                          >
                            {icon}
                            <span>{menu.label}</span>
                          </Link>
                        </SidebarMenuButton>
                      </SidebarMenuItem>
                    );
                  })}
                </SidebarMenu>
              </SidebarGroupContent>
            </SidebarGroup>
          );
        })}
      </SidebarContent>

      <SidebarFooter></SidebarFooter>
    </Sidebar>
  );
}
